import { render, staticRenderFns } from "./LinkProductAndAds.vue?vue&type=template&id=5e416dd3&scoped=true&"
import script from "./LinkProductAndAds.vue?vue&type=script&lang=js&"
export * from "./LinkProductAndAds.vue?vue&type=script&lang=js&"
import style0 from "./LinkProductAndAds.vue?vue&type=style&index=0&id=5e416dd3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e416dd3",
  null
  
)

export default component.exports